import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { TokenStorageService } from '../_services/token-storage.service';
import {AuthService} from '../_services/auth.service';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  @Output() showWindow = new EventEmitter<boolean>();
  currentUser: any;
  oldUserName = '';
  isBusy = false;
  isUpdateFailed = false;
  errorMessage = '';

  constructor(private token: TokenStorageService, private authService: AuthService,
              private messageService: MessageService) { }

  ngOnInit(): void {
    this.currentUser = this.token.getUser();
    this.oldUserName = this.currentUser.username;
  }

  onSubmit(): void {
    const { username, firstname, lastname, company, email } = this.currentUser;

    this.isBusy = true;
    this.authService.update(this.oldUserName, username, firstname, lastname, company, email).subscribe(
        data => {
          this.isBusy = false;
          console.log(data);
          this.isUpdateFailed = false;
          let msgType = 'success';
          if (data.message.startsWith('Error')) {
            msgType = 'error';
          } else {
            this.showWindow.emit(false);
          }
          if(this.oldUserName != username) {
              this.token.signOut();
              window.location.replace('/#/login');
              this.messageService.add({key: 'bc', severity:msgType, summary: 'Message', life: 5000,
                  detail: data.message + ' Because you changed your user name, please log in again with the new user name.'});
          } else {
              this.messageService.add({key: 'bc', severity: msgType, summary: 'Message', life: 3000, detail: data.message});
          }
        },
        err => {
          this.isBusy = false;
          this.errorMessage = err.error.message;
          this.isUpdateFailed = true;
        }
    );
  }
}
